import {
  JoinExpConfig,
} from '@tenants/types';
import {
  GTM_CLICK_BUILT_FOR_THIS_JOIN_US_BUTTON_JOIN_EXP,
  GTM_CLICK_GET_NOW_BUTTON_JOIN_EXP,
  GTM_CLICK_JOIN_NOW_FAB_JOIN_EXP,
  GTM_CLICK_LEARN_MORE_BUTTON_JOIN_EXP,
  GTM_CLICK_SIGN_ME_UP_BUTTON_JOIN_EXP,
} from 'constants/events';
import {
  createGlennSanfordQuote,
  createLeoParejaQuote,
} from '@tenants/definitions/exp/shared/quotes';
import { createVideoCardsData } from '@tenants/definitions/exp/shared/video-cards-data';
import { createPowerOfExpData } from '@tenants/definitions/exp/shared/power-of-exp-data';
import { createCardStackData } from '@tenants/definitions/exp/shared/card-stack-data';
import { createProgramData } from '@tenants/definitions/exp/shared/programs-data';
import { createFaqData } from '@tenants/definitions/exp/shared/faq-data';
import { Colors } from 'constants/colors';
import { getJoinExpFabDestination } from 'constants/urls';
import { SiteLanguage } from 'types/locales';
import { LOCALE_JOIN_EXP_US_PATHS, Namespaces } from 'types/locales';

//#region Public Constants
export const EXP_REALTY_US_JOIN_PAGE_CONTACT_PATH = '/contact';
export const EXP_REALTY_US_JOIN_PAGE_CONTACT_PAGE = '/join-exp-us-contact';
//#endregion

//#region Join Exp Config
export function createJoinExpConfig(): JoinExpConfig {
  const joinExpConfig: JoinExpConfig = {
    joinPageContactPage: EXP_REALTY_US_JOIN_PAGE_CONTACT_PAGE,
    joinPageContactPath: EXP_REALTY_US_JOIN_PAGE_CONTACT_PATH,
    learnMoreClickEvent: GTM_CLICK_LEARN_MORE_BUTTON_JOIN_EXP,
    signMeUpClickEvent: GTM_CLICK_SIGN_ME_UP_BUTTON_JOIN_EXP,
    getNowClickEvent: GTM_CLICK_GET_NOW_BUTTON_JOIN_EXP,
    fabDestination: getJoinExpFabDestination(),
    fabClickEvent: GTM_CLICK_JOIN_NOW_FAB_JOIN_EXP,
    quotes: {
      glenn: createGlennSanfordQuote(Namespaces.JOIN_EXP_US, Colors.expPrimaryBrandRoyal, 'highlight'),
      leo: createLeoParejaQuote(Namespaces.JOIN_EXP_US, Colors.expPrimaryBrandRoyal, 'highlight'),
    },
    videoCardData: createVideoCardsData(Namespaces.JOIN_EXP_US),
    cardStackData: createCardStackData(Namespaces.JOIN_EXP_US),
    programsData: createProgramData(Namespaces.JOIN_EXP_US),
    faq: createFaqData(Namespaces.JOIN_EXP_US, EXP_REALTY_US_JOIN_PAGE_CONTACT_PATH),
    powerOfExpData: createPowerOfExpData(Namespaces.JOIN_EXP_US),
    builtForThis: {
      label: LOCALE_JOIN_EXP_US_PATHS.JOINUS,
      clickEvent: GTM_CLICK_BUILT_FOR_THIS_JOIN_US_BUTTON_JOIN_EXP,
      logo: {
        [SiteLanguage.English]: {
          src: 'assets/images/join-exp/logo.en.svg',
          alt: 'logo',
          width: 1622,
          height: 142,
        },
        [SiteLanguage.EnglishCA]: {
          src: 'assets/images/join-exp/logo.en.svg',
          alt: 'logo',
          width: 1622,
          height: 142,
        },
        [SiteLanguage.French]: {
          src: '/assets/images/join-exp/logo.fr.svg',
          alt: 'logo',
          width: 3649,
          height: 309,
        },
        [SiteLanguage.FrenchCA]: {
          src: '/assets/images/join-exp/logo.fr.svg',
          alt: 'logo',
          width: 3649,
          height: 309,
        },
        [SiteLanguage.Spanish]: {
          src: '/assets/images/join-exp/logo.es.svg',
          alt: 'logo',
          width: 2747,
          height: 157,
        },
      },
      video: {
        [SiteLanguage.English]: {
          src: '/assets/video-section1.mp4',
          type: 'video/mp4',
        },
        [SiteLanguage.EnglishCA]: {
          src: '/assets/video-section1.mp4',
          type: 'video/mp4',
        },
        [SiteLanguage.French]: {
          src: '/assets/video-section1.mp4',
          type: 'video/mp4',
        },
        [SiteLanguage.FrenchCA]: {
          src: '/assets/video-section1.mp4',
          type: 'video/mp4',
        },
        [SiteLanguage.Spanish]: {
          src: '/assets/video-section1.mp4',
          type: 'video/mp4',
        },
      },
    },
  };
  return joinExpConfig;
}
//#endregion